<template>
  <div style="width:100%; padding-top: 60px">
    <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
        <screenButton class="screenButton"></screenButton>
      </div>
    </div>

    <b-table class="bgc-dark" head-variant="dark" responsive bordered
             :items="items" :fields="fields1">
      <template v-slot:head()="scope">
        <div class="text-nowrap" style="text-align:center; vertical-align: middle;">
          {{ scope.label }}
        </div>
      </template>
      <template v-slot:cell(index)="data">
        {{ data.index + 1 }}
      </template>

      <template v-slot:cell(plotNames)="data">
        <span v-if="data.item.plotNames" style="color: #4caedc" @click="showDetail(data.item.plotNames)">{{ data.item.plotNames }}</span>
        <span v-else>/</span>
      </template>

      <template v-slot:cell(muCount)="data">
        <span v-if="data.item.muCount !== null && data.item.muCount !== undefined && data.item.muCount !== ''">{{ data.item.muCount }}</span>
        <span v-else>/</span>
      </template>

      <template v-slot:cell(treeAgeLabel)="data">
        <span v-if="data.item.treeAgeLabel">{{ data.item.treeAgeLabel }}</span>
        <span v-else>/</span>
      </template>

      <template v-slot:cell(phenophaseInfoName)="data">
        <span v-if="data.item.phenophaseInfoName">{{ data.item.phenophaseInfoName }}</span>
        <span v-else>/</span>
      </template>

      <template v-slot:cell(workHoursPerCapita)="data">
        {{ Number(data.item.workHoursPerCapita).toFixed(1) }}
      </template>
      <template v-slot:cell(attachList)="data">
        <div style="color: #4caedc" v-for="(file,index) in data.item.attachList" @click="$viewAttach(file)">{{ file.name }}</div>
      </template>

      <template v-slot:cell(remarks)="data">
        <div style="color: #4caedc" @click="showDetail(data.item.remarks)">{{ data.item.remarks }}</div>
      </template>

      <template v-slot:table-colgroup="scope">
        <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="{ width: field.width }"
        >
      </template>
    </b-table>
  </div>
</template>

<script>
import {Decimal} from "decimal.js";
import moment from "moment";
import QueryInfoService from "@/api/system/queryInfoService";

export default {
  name: "ApmsRegFarmingInfoDetail",
  data() {
    return {
      fields1: [
        {key: 'index', stickyColumn: true, label: '序号', width: '55px'},
        {key: 'plotNames', label: '地块', width: '200px'},
        {key: 'muCount', label: '亩数', width: '100px'},
        {key: 'treeAgeLabel', label: '树龄', width: '90px'},
        {key: 'phenophaseInfoName', label: '物候期', width: '110px'},
        {key: 'operationName', label: '农事操作', width: '130px'},
        {key: 'laborTeamName', label: '班组', width: '110px'},
        {key: 'peopleCount', label: '人数', width: '110px'},
        {key: 'workHoursPerCapita', label: '人均工作时长（小时）', width: '180px'},
        {key: 'attachList', label: '附件', width: '140px'},
        {key: 'remarks', label: '备注', width: '120px'},
      ],
      items: [],
      treeAgeDict: [],
    }
  },
  created() {
    this.items = JSON.parse(this.$route.query.data)
    this.getDict()
  },
  methods: {
    init() {},
    goBack() {
      this.$router.back()
    },
    getDict() {
      new QueryInfoService().getDictMap().then(({data}) => {
        this.treeAgeDict = data['apms_tree_age'] || []
        this.updateTreeAgeLabels()
      }).catch(e => {
        console.log(e)
      })
    },
    updateTreeAgeLabels() {
      this.items.forEach(item => {
        if (item.treeAge !== null && item.treeAge !== undefined && item.treeAge !== '') {
          const dictItem = this.treeAgeDict.find(d => d.value == item.treeAge)
          this.$set(item, 'treeAgeLabel', dictItem ? dictItem.label : '')
        } else {
          this.$set(item, 'treeAgeLabel', '')
        }
      })
    },
    showDetail(content) {
      this.$dialog.alert({
        message: content || '/',
        showConfirmButton: true,
        confirmButtonText: '关闭',
      }).catch(() => {})
    },
  }
}
</script>

<style scoped>
</style>
